export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10626.a6e9f001.jpg";